// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"b03e801f","659":"b03e801f","706":"2ccf379c","964":"b03e801f","990":"2ccf379c"}[chunkId] + ".chunk.css";
};